import { request } from "#/utils/request";

export interface IBens {
  codigoComissionado: string;
  idProduto: number;
  idSubProduto: number;
  valorCredito: number;
  documento: string;
  tipoCredito: TipoVenda;
  idTipoVenda: number;
  situacaoGrupo: string;
}

export interface IBensData {
  data: BensGruposReturn[];
  errors: IBensErrors;
}

interface IBensErrors {
  message: string;
  code: number;
}

export interface BensGruposReturn {
  codigoGrupo: string;
  idGrupo: number;
  situacaoGrupo: string;
  prazoComercializacao: number;
  prazoRestante: number;
  idPlanoVenda: number;
  idTaxaPlano: number;
  quantidadeParticipante: number;
  idBem: number;
  valorBem: number;
  percentualTaxaAdm: number;
  percentualTaxaAdmDesconto: number;
  valorParcela: number;
  valorParcelaDesconto: number;
  segmentoBem: string;
  valorLanceMedio: number;
  idDesconto: number;
  idSimulacao: number;
  possivelContratar: boolean;
  melhorProposta: boolean;
}

export enum TipoVenda {
  parcela = "P",
  credito = "V",
}

/** Endpoints */
export const getBens = async ({
  codigoComissionado,
  idProduto,
  idSubProduto,
  valorCredito,
  documento,
  tipoCredito,
  idTipoVenda,
  situacaoGrupo,
}: IBens) =>
  (
    await request.get<IBensData>(
      `/bens?codigoComissionado=${codigoComissionado}&idProduto=${idProduto}&idSubProduto=${idSubProduto}&valorCredito=${valorCredito}&documento=${documento}&tipoCredito=${tipoCredito}&idTipoVenda=${idTipoVenda}&situacaoGrupo=${situacaoGrupo}`,
      {}
    )
  ).data;
